// ============================================================
// DFN3 Configuration - Option B Architecture (Host-Side STFT)
// ============================================================

// ONNX Model: Neural network core only (no STFT/ISTFT)
// Inputs: spec (B,1,T,481,2), feat_erb (B,1,T,32), feat_spec (B,1,T,96,2)
// Outputs: enhanced_spec (B,1,T,481,2), erb_gains, lsnr
export const DFN3_MODEL_URL = '/dfn3/models/dfn3_core_opset13.onnx';

// WASM DSP Module: STFT/ISTFT/ERB feature extraction
export const DFN3_DSP_WASM_URL = '/dfn3/wasm-dsp/dfn3_dsp.js';

// ONNX Runtime WASM files
export const DFN3_ORT_WASM_BASE_URL = '/dfn3/onnxruntime-web/';

// Audio parameters (fixed for DFN3)
export const DFN3_SAMPLE_RATE = 48000;
export const DFN3_FFT_SIZE = 960;
export const DFN3_HOP_SIZE = 480; // 10ms at 48kHz
export const DFN3_FREQ_SIZE = 481; // FFT_SIZE / 2 + 1
export const DFN3_NB_ERB = 32;
export const DFN3_NB_DF = 96;
export const DFN3_MIN_TIME_FRAMES = 5; // conv_lookahead (2) + 3

// Legacy: State size for old streaming model (not used in v2)
export const DFN3_STATE_SIZE = 1;

// Runtime flags
export const DFN3_ENABLE_RNNOISE_FALLBACK = true;

// DFN3 runtime info helper
export const DFN3_INFO = {
  modelUrl: DFN3_MODEL_URL,
  dspWasmUrl: DFN3_DSP_WASM_URL,
  ortWasmPath: DFN3_ORT_WASM_BASE_URL,
  sampleRate: DFN3_SAMPLE_RATE,
  fftSize: DFN3_FFT_SIZE,
  hopSize: DFN3_HOP_SIZE,
  freqSize: DFN3_FREQ_SIZE,
  nbErb: DFN3_NB_ERB,
  nbDf: DFN3_NB_DF,
  minTimeFrames: DFN3_MIN_TIME_FRAMES,
  expectedOpset: 13,
};
